var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 6.07666C8.83203 5.66245 8.49624 5.32666 8.08203 5.32666C7.66782 5.32666 7.33203 5.66245 7.33203 6.07666V17.9236C7.33203 18.3378 7.66782 18.6736 8.08203 18.6736C8.49625 18.6736 8.83203 18.3378 8.83203 17.9236L8.83203 6.07666Z",
    fill: "#164A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 6.07666C16.668 5.66245 16.3322 5.32666 15.918 5.32666C15.5038 5.32666 15.168 5.66245 15.168 6.07666L15.168 17.9236C15.168 18.3378 15.5038 18.6736 15.918 18.6736C16.3322 18.6736 16.668 18.3378 16.668 17.9236L16.668 6.07666Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.57132e30c7fe9934d58ea937092d19d4.svg";
export { ForwardRef as ReactComponent };